import { useUserStore } from '../../stores/user.js';

const verifyAlterisEmail = (to, from) => {
  const userStore = useUserStore();
  if (import.meta.env.VITE_APP_ENV === 'production' && userStore.currentUser.email.endsWith('@alterisgroup.com')) {
    return true;
  } else if (['qa', 'development', 'staging'].includes(import.meta.env.VITE_APP_ENV)) {
    return true;
  }

  return { path: '/schools' };
}
export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/index.vue'),
    // TODO temporarily opening this route up so that Angie can test it on production (UI to navigate to this route has been disabled
  },
];
